/**
 * Default empty state for OmnisearchDataGridV2 — mirrors V1 OmnisearchDataGrid behavior.
 *
 * When the user has active filters/search: "No results found." + Clear search button.
 * When the dataset is empty with no filters: shows `noDataMessage` (+ optional action button).
 */

import { NoRowsOverlay } from "routes/Customer/Chemicals/Inventory/Facility/NoRowsOverlay";

import { useOmnisearchActions, useOmnisearchStore } from "./omnisearchStore";

const DEFAULT_NO_DATA_MESSAGE = "No results found.";

export interface DefaultEmptyStateOverlayProps {
  /** Message when there is no data and no active omnisearch filter */
  noDataMessage?: string | string[];
  /** Button label when there is no data and no active omnisearch filter */
  noDataButtonText?: string;
  /** Button handler when there is no data and no active omnisearch filter */
  onNoDataButtonClick?: () => void;
}

export function DefaultEmptyStateOverlay({
  noDataMessage = DEFAULT_NO_DATA_MESSAGE,
  noDataButtonText,
  onNoDataButtonClick,
}: DefaultEmptyStateOverlayProps) {
  const { omnisearch } = useOmnisearchStore();
  const { setOmnisearchImmediate } = useOmnisearchActions();

  const hasActiveSearch = omnisearch.trim().length > 0;

  if (hasActiveSearch) {
    return (
      <NoRowsOverlay
        message="No results found."
        buttonText="Clear search"
        onButtonClick={() => setOmnisearchImmediate("")}
      />
    );
  }

  return (
    <NoRowsOverlay
      message={noDataMessage}
      buttonText={noDataButtonText}
      onButtonClick={onNoDataButtonClick}
      showButton={!!noDataButtonText}
    />
  );
}
